import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from '../../utils/providerHOC/providerHOC';
import store from '../headerStore';
import miniCartContainer from './miniCartContainer';

import { MINI_CART_ROOT_ELEMENT } from './miniCartConstants';
import { fetchMiniCart } from './miniCartActions';

// Safe one-time pageshow listener
// eslint-disable-next-line no-underscore-dangle
if (!window.__MINI_CART_PAGESHOW_LISTENER_ATTACHED__) {
  window.addEventListener('pageshow', event => {
    if (event.persisted || window.performance?.navigation?.type === 2) {
      store.dispatch(fetchMiniCart());
    }
  });
  // eslint-disable-next-line no-underscore-dangle
  window.__MINI_CART_PAGESHOW_LISTENER_ATTACHED__ = true;
}

const MiniCartRoot = providerHOC(store)(miniCartContainer);
createRoot(MINI_CART_ROOT_ELEMENT).render(<MiniCartRoot />);
